<template>
    <div class="c-o-company-section c-o-company-section--ratings" id="ratings">
        <div class="c-o-company-section__inner c-o-company-section__inner--centered c-o-company-section__inner--no-padding-bottom">
            <div class="c-o-company-section__main">
                <h2 class="c-o-company-section__title h2">Kundomdömen</h2>
                <p class="c-o-company-section__body">Här kan du se de senaste omdömen för <b>{{company.Name}}</b>.</p>
            </div>
        </div>
        <div class="c-o-company-section__inner c-o-company-section__inner--no-padding-top">
            <div class="c-o-company-section__ratings">
                <div class="c-o-company-section__ratings-inner">
                    <rating
                        v-for="(item, key) in slicedRatings"
                        :key="`rating-${item.RatId}`"
                        :rating="item"
                        :company="company"
                    >
                    </rating>
                </div>
                <pagination
                    :totalItemsProp="company.Ratings.length"
                    :itemsPerPageProp="5"
                    :maxPagesToShowProp="5"
                    :currentPageProp="page"
                    @changed="goToPage"
                ></pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from '../../atoms/AtomIcon.vue'
    import Rating from '../../molecules/MoleculeRating.vue'
    import Pagination from '../../molecules/MoleculePagination.vue'

    export default {
        data() {
            return {
                page: 1
            }
        },
        components: {
            Icon,
            Rating,
            Pagination
        },
        props: [
            'company'
        ],
        computed: {
            slicedRatings: function(){
                if (this.company.Ratings.length <= 5) {
                    return this.company.Ratings
                } else {
                    return this.company.Ratings.slice((5 * this.page) - 5, 5 * this.page);
                }
            }
        },
        methods: {
            goToPage(page) {
                this.page = page;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/company-sections/OrganismCompanySectionRatings.vue